import { createDocument, getAllData } from "apis/customApiHandler";
import Spinner from "components/Spinner";
import { Input, Select } from "styled";
import { Fragment, useCallback, useEffect, useState, useRef } from "react";
import { BiCloudDownload } from "react-icons/bi";
import { useQuery } from "react-query";
import ReactSelect from "react-select";
import { TD, TH } from "styled/table";
import exportExcel, { exportExcelStyled } from "utils/exportExcel";
import Modal from "components/Modal";
import { Button } from 'styled';
import getFormattedDate, { convertSlashToDash, convertToIndianTimezoneAndGetDate, titleCase } from "utils/helpers";
import axios from 'apis/axios'
import toast from 'react-hot-toast';
import { IoMdArrowBack, IoMdArrowForward } from "react-icons/io";

const getOneYearAgoDate = () => {
    const today = new Date();
    const oneYearAgo = new Date(today.setFullYear(today.getFullYear() - 1));
    const year = oneYearAgo.getFullYear();
    const month = String(oneYearAgo.getMonth() + 1).padStart(2, '0');
    const day = String(oneYearAgo.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const getOneYearFromDate = (date) => {
    const givenDate = new Date(date);
    const oneYearFromDate = new Date(givenDate.setFullYear(givenDate.getFullYear() + 1));
    return getFormattedDate(oneYearFromDate);
};


const MonthWiseTyreTrendReport = () => {

    const [selectedFleets, setSelectedFleets] = useState([]);
    const [selectedHubs, setSelectedHubs] = useState([]);
    const [fleetMap, setFleetMap] = useState({});
    const [reportType, setReportType] = useState("");
    const [tyreCategory, setTyreCategory] = useState([]);
    const [chalansFor, setChalansFor] = useState("");
    const [searchReportType, setSearchReportType] = useState("");
    const [dateFrom, setDateFrom] = useState(getOneYearAgoDate());
    const [dateTo, setDateTo] = useState(getFormattedDate(new Date()));
    const [data, setData] = useState([]);
    const[detailModalData,setDetailModalData]=useState([])
    const [isLoading, setIsLoading] = useState(false);
    const [downloading, setDownloading] = useState(false);
    const [page, setPage] = useState(1);
    const [initialLoad, setInitialLoad] = useState(true)
    const [availableCategoryCodes, setAvailableCategoryCodes] = useState([]);
    const [loadingCategories, setLoadingCategories] = useState(false);
    const dateFromRef = useRef(dateFrom);
    const dateToRef = useRef(dateTo);
    let limit = 40;
    const monthMap = ["", "Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];

    console.log('detailModalData--',detailModalData);

    const { data: allFleets } = useQuery([`/customer-fleet`], () =>
        getAllData("/customer-fleet", {
            limit: 3000,
        })
    );
    const { data: allCategories } = useQuery([`product-cats`], () =>
        getAllData("/product/getCategories", {
          limit: 300,
          page: 1,
        }),
      );

    const { data: allHubs } = useQuery([`/customer-hub`], () =>
        getAllData("/customer-hub", {
            limit: 3000,
        })
    );

    const getFleetOptions = useCallback(() => {
        if (allFleets && allFleets.data && allFleets.data.length) {
            return [
                {
                    label: "All",
                    value: "all",
                },
                {
                    label: "Clear",
                    value: "clear",
                },
                ...allFleets?.data?.map((fleet) => {
                    return {
                        value: fleet._id,
                        label: fleet.fleetName,
                    };
                }),
            ];
        }
    }, [allFleets]);

    const getHubOptions = useCallback(() => {
        if (allHubs && allHubs.data && allHubs.data.length) {
            return [
                ...selectedFleets?.length ? [{
                    label: "All",
                    value: "all",
                  }]: [],
                  ...selectedFleets?.length ? [{
                    label: "Clear",
                    value: "clear",
                  }]: [],
                ...(selectedFleets?.includes("all") ?
                    allHubs?.data?.length &&
                    allHubs?.data
                        ?.map((hub) => {
                            return {
                                value: hub.hubCode,
                                label: hub.hubName,
                            };
                        }) :
                    allHubs?.data?.length &&
                    allHubs?.data
                        ?.filter((hub) => {
                            const selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                                selectedFleets?.includes(fleet._id)
                            );

                            return selectedFleetsVal?.some(
                                (fleet) => fleet.fleetCode === hub.fleetCode
                            );
                        })
                        ?.map((hub) => {
                            return {
                                value: hub.hubCode,
                                label: hub.hubName,
                            };
                        })),
            ];
        }
    }, [allFleets, allHubs, selectedFleets]);

    const fetchAvailableCategories = useCallback(async () => {
        const fromDate = dateFromRef.current;
        const toDate = dateToRef.current;
        
        if (!selectedHubs.length || !fromDate || !toDate) {
            setAvailableCategoryCodes([]);
            setLoadingCategories(false);
            return;
        }

        setLoadingCategories(true);
        try {
            const hubsToSend = selectedHubs.includes("all") 
                ? getHubOptions()?.filter(item => item.value !== "all" && item.value !== "clear")
                    .map((item) => item.value)
                    .join(",")
                : selectedHubs.join(",");

            if (!hubsToSend) {
                setAvailableCategoryCodes([]);
                setLoadingCategories(false);
                return;
            }

            const payload = {
                hubCodes: hubsToSend,
                from: fromDate,
                to: toDate,
                ...(chalansFor && { for: chalansFor }),
            };

            const response = await createDocument("/report/monthWiseSuppliedTyresTrend/availableCategories", payload);
            
            if (response?.data) {
                setAvailableCategoryCodes(response.data);
            } else {
                setAvailableCategoryCodes([]);
            }
        } catch (err) {
            console.error("Error fetching available categories:", err);
            setAvailableCategoryCodes([]);
        } finally {
            setLoadingCategories(false);
        }
    }, [selectedHubs, chalansFor, getHubOptions]);

    const handleDateBlur = useCallback(() => {
        setTimeout(() => {
            if (selectedHubs.length && dateFromRef.current && dateToRef.current) {
                fetchAvailableCategories();
            } else {
                setAvailableCategoryCodes([]);
            }
        }, 100);
    }, [selectedHubs, fetchAvailableCategories]);

    useEffect(() => {
        if (selectedHubs.length && dateFromRef.current && dateToRef.current) {
            fetchAvailableCategories();
        } else {
            setAvailableCategoryCodes([]);
        }
    }, [selectedHubs, chalansFor, fetchAvailableCategories]);

    useEffect(() => {
        if (tyreCategory && availableCategoryCodes.length > 0 && allCategories?.data) {
            const selectedCategory = allCategories.data.find(item => item.categoryName === tyreCategory);
            if (selectedCategory) {
                const categoryCodes = selectedCategory.catCodes || [];
                const hasAvailableData = categoryCodes.some(code => availableCategoryCodes.includes(code));
                if (!hasAvailableData) {
                    setTyreCategory("");
                }
            }
        }
    }, [availableCategoryCodes, tyreCategory, allCategories]);

    const getData = useCallback(async (isDetailView = false) => {
        if ((dateFrom && !dateTo) || (!dateFrom && dateTo)) {
            toast.error("Both Start Date and End Date must be provided together.");
            setData([]);
            return;
          }
        setIsLoading(true);
        
        try {
            const apiEndpoint = isDetailView 
                ? "/report/monthWiseSuppliedTyresTrend/modalInfo" 
                : reportType === "fleet" ? "/report/grnStatusLastFourMonths"
                : "/report/monthWiseSuppliedTyresTrend";
    
            const fleetsToSend = selectedFleets.includes("all") 
                ? allFleets?.data?.map(fleet => fleet._id).join(",") 
                : selectedFleets.join(",");
    
            const hubsToSend = selectedHubs.includes("all") 
                ? allHubs?.data?.map(hub => hub._id).join(",") 
                : selectedHubs.join(",");
            let dateFilter = {
                ...reportType === "fleet" ? {
                    ...(dateFrom && { dateFrom: dateFrom }),
                    ...(dateTo && { dateTo: dateTo }),
                }:{
                    ...(dateFrom && { from: dateFrom }),
                    ...(dateTo && { to: dateTo }),
                }
            }
            const payload = isDetailView
                ? { 
                    fleets: fleetsToSend,
                    from: dateFrom,
                    to: dateTo,
                    page: page ?? 1,
                    limit: limit,
                    ...(selectedHubs?.includes("all")
                        ? {
                            hubCodes: (getHubOptions && getHubOptions())?.filter(item => item.value !== "all" && item.value !== "clear")
                                .map((item) => item.value)
                                .join(","),
                        }
                        : selectedHubs.length && {
                            hubCodes: selectedHubs.map((hub) => hub).join(","),
                        }),
                    reportType: reportType,
                    ...(chalansFor && { for: chalansFor }),
                    tyreCategory: allCategories?.data?.find(item => item.categoryName === tyreCategory)?.catCodes,
                }
                : {
                    ...(selectedFleets?.includes("all")
                        ? {
                            fleets: (getFleetOptions && getFleetOptions())?.filter(item => item.value !== "all" && item.value !== "clear")
                                .map((item) => item.value)
                                .join(","),
                        }
                        : selectedFleets.length && {
                            fleets: selectedFleets.map((fleet) => fleet).join(","),
                        }),
                    ...(selectedHubs?.includes("all")
                        ? {
                            hubCodes: (getHubOptions && getHubOptions())?.filter(item => item.value !== "all" && item.value !== "clear")
                                .map((item) => item.value)
                                .join(","),
                        }
                        : selectedHubs.length && {
                            hubCodes: selectedHubs.map((hub) => hub).join(","),
                        }),
                    ...dateFilter,
                    ...(reportType && { reportType: reportType }),
                    ...(chalansFor && { for: chalansFor }),
                    tyreCategory: allCategories?.data?.find(item => item.categoryName === tyreCategory)?.catCodes
                };
    
            const dt = await createDocument(apiEndpoint, payload);
    
            if (dt?.data) {
                if (isDetailView) {
                    setDetailModalData(dt)
                    setSearchReportType(reportType);
                }
                else {
                    setData(dt);
                    setSearchReportType(reportType);
                }

            }
        } catch (err) {
            console.error("Error fetching data:", err);
        } finally {
            setIsLoading(false);
            if(initialLoad) setInitialLoad(false)
        }
    }, [dateFrom, dateTo, selectedFleets, selectedHubs, reportType, page, limit, chalansFor, tyreCategory, allFleets, allHubs, allCategories, initialLoad, getHubOptions, getFleetOptions]);

    useEffect(()=>{
        console.log(page)
        if(reportType === "detail" && !initialLoad) {
            getData(reportType === "detail" ? true : false)
        }
    }, [page, reportType, initialLoad])

    // Update refs when dates change
    useEffect(() => {
        dateFromRef.current = dateFrom;
        dateToRef.current = dateTo;
    }, [dateFrom, dateTo]);

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        console.log("selectedDate", e.target.value)

        setDateFrom(selectedDate);

        const oneYearAheadDate = new Date(selectedDate);
        oneYearAheadDate.setFullYear(oneYearAheadDate.getFullYear() + 1);
        oneYearAheadDate.setDate(oneYearAheadDate.getDate() - 1);

        const currentDate = new Date();

        const finalDate = oneYearAheadDate > currentDate ? currentDate : oneYearAheadDate;
        setDateTo(getFormattedDate(finalDate));
    };


    const getDownloadData = async () => {
        if ((dateFrom && !dateTo) || (!dateFrom && dateTo)) {
            toast.error("Both Start Date and End Date must be provided together.");
            return;
          }
        setDownloading(true);
        try {
            let isDetailView = reportType === "detail"
            const apiEndpoint = isDetailView 
                ? "/report/monthWiseSuppliedTyresTrend/modalInfo" 
                : reportType === "fleet" ? "/report/grnStatusLastFourMonths"
                : "/report/monthWiseSuppliedTyresTrend";
    
            const fleetsToSend = selectedFleets.includes("all") 
                ? allFleets?.data?.map(fleet => fleet._id).join(",") 
                : selectedFleets.join(",");
    
            const hubsToSend = selectedHubs.includes("all") 
                ? allHubs?.data?.map(hub => hub._id).join(",") 
                : selectedHubs.join(",");
            let dateFilter = {
                ...reportType === "fleet" ? {
                    ...(dateFrom && { dateFrom: dateFrom }),
                    ...(dateTo && { dateTo: dateTo }),
                }:{
                    ...(dateFrom && { from: dateFrom }),
                    ...(dateTo && { to: dateTo }),
                }
            }
            const payload = isDetailView
                ? { 
                    fleets: fleetsToSend,
                    from: dateFrom,
                    to: dateTo,
                    // page: page,
                    // limit: limit,
                    ...(selectedHubs?.includes("all")
                        ? {
                            hubCodes: getHubOptions().filter(item => item.value !== "all" && item.value !== "clear")
                                .map((item) => item.value)
                                .join(","),
                        }
                        : selectedHubs.length && {
                            hubCodes: selectedHubs.map((hub) => hub).join(","),
                        }),
                    reportType: reportType,
                    fetchAll: 1,
                    ...(chalansFor && { for: chalansFor }),
                    tyreCategory: allCategories?.data?.find(item => item.categoryName === tyreCategory)?.catCodes
                }
                : {
                    ...(selectedFleets?.includes("all")
                        ? {
                            fleets: getFleetOptions().filter(item => item.value !== "all" && item.value !== "clear")
                                .map((item) => item.value)
                                .join(","),
                        }
                        : selectedFleets.length && {
                            fleets: selectedFleets.map((fleet) => fleet).join(","),
                        }),
                    ...(selectedHubs?.includes("all")
                        ? {
                            hubCodes: getHubOptions().filter(item => item.value !== "all" && item.value !== "clear")
                                .map((item) => item.value)
                                .join(","),
                        }
                        : selectedHubs.length && {
                            hubCodes: selectedHubs.map((hub) => hub).join(","),
                        }),
                    ...dateFilter,
                    ...(reportType && { reportType: reportType }),
                    ...(chalansFor && { for: chalansFor }),
                    tyreCategory: allCategories?.data?.find(item => item.categoryName === tyreCategory)?.catCodes
                };
    
            const dt = await createDocument(apiEndpoint, payload);

            if (dt.data) {
                const monthNames = dt.months?.map(month => {
                    const [year, monthNum] = month.split("-");
                    return `${monthMap[parseInt(monthNum)]} ${year}`;
                });
    
                let exportData;

                if (reportType === "zone" || reportType === "region") {
                    let totalRow = {
                        "Zone": "Total",
                        Total: dt?.totalRow.total ?? 0,
                    };
    
                    dt.months?.forEach((month, monthIdx) => {
                        
                        const monthKey = monthNames[monthIdx];

                        console.log('monthKey--',monthKey,dt);
                        
                        totalRow[monthKey] = dt?.totalRow[month] ?? 0;

                    });

                    
    
                    exportData = [
                        ...dt.data?.map((entry, idx) => {
                            console.log('entry--',entry);
                            
                            const monthWise = {};
                            dt.months.forEach((month, monthIdx) => {
                                console.log('monthKey--',monthNames[monthIdx]);
                                const monthKey = monthNames[monthIdx];
                                const monthInfo = entry[month]
                                console.log('monthInfo--',monthInfo);
                                
                                monthWise[monthKey] = monthInfo ? monthInfo : 0;
                            });                            
                            if(reportType === "zone"){
                                return {
                                    "Zone":entry?._id?.Zone,
                                    // "Region": dt?.data[0]?._id?.Region ? dt?.data[0]?._id?.Region : 'NA',
                                    ...monthWise,
                                    Total: entry?.count
                                    // Total: entry.monthWiseInfo.reduce((acc, curr) => acc + curr.chalanInfo.length, 0),
                                };

                            }else{
                                return {
                                    "Zone": entry?.Zone,
                                    "Region": entry?._id?.Region ? dt?.data[idx]?._id?.Region : 'NA',
                                    ...monthWise,
                                    Total: entry?.count
                                    // Total: entry.monthWiseInfo.reduce((acc, curr) => acc + curr.chalanInfo.length, 0),
                                };
                            }
                        }),
                        totalRow
                    ];
                }
                 else if (reportType === "fleet") {
                    exportData = dt.data.map(entry => ({
                        "Fleet Name": `${entry.fleet} (${entry?.fleetCity ?? "---"})`,
                        "Hub Name": entry.hubName ?? 0,
                        "Supplied Stencil": entry.sumOfTotaltyres,
                        "Accepted Tyre": (entry.sumOfTyreAccepted ?? 0) + (entry.sumOfTyreRejected ?? 0),
                        "Tyre Pending": entry.sumOfPending ?? 0,
                    }));
    
                    const totalRow = {
                        "Fleet Name": "Total",
                        "Hub Name": "",
                        "Supplied Stencil": dt?.totalRow?.total ?? 9,
                        "Accepted Tyre": (dt?.totalRow?.accepted ?? 0) + (dt?.totalRow?.acceptedWithChanges ?? 0),
                        "Tyre Pending": dt?.totalRow?.pending ?? 0,
                    };
    
                    exportData.push(totalRow);

                } else if(reportType === "detail"){                    

                    console.log(dt.data[0]);
                    

                    exportData = dt.data.map(entry =>({
                        "GRN Date" : entry?.grnDate,
                        "Fleet Name": `${entry?.fleetName} (${entry?.fleetCity ?? "---"})`,
                        "Hub Name" : entry?.hubName,
                        "Depot Code" : entry?.depoCode,
                        "Region" : entry?.region,
                        "Zone" : entry?.zone,
                        "Tyre Size" : entry?.tyreSize,
                        "Tyre Brand" : entry?.brand || "---",
                        "Grn Number" : entry?.Challan_No,
                        "Stencil Number" : entry?.RecvStencil,
                        "Accepted Date" : entry?.acceptedAt ? convertToIndianTimezoneAndGetDate(entry?.acceptedAt): entry?.grnDate,
                        "Accepted By" : entry?.acceptedBy,
                        "Fitment Date": entry?.fitmentDate
                        ? entry.fitmentDate
                        : entry?.soldOutDate
                            ? entry.soldOutDate
                            : "---",

                        "In Stock" : entry?.inStock,
                        "For" : entry?.for === "Pending" ? "Fitment Pending" : titleCase(entry?.for),
                        "Vehicle" : (entry?.vehicle),
                        "First Enrollment vehicle" : entry?.firstEnrollmentVehicle || "---",
                    }))

                }
    
                console.log("exportData", exportData);
    
                if (reportType === "detail") {
                  exportExcelStyled(exportData, "Month Wise Tyre Trend Report", {
                    redColumn: "Stencil Number",
                    redRows: dt.data.map((entry) => !!entry?.soldOut),
                  });
                } else {
                  exportExcel(exportData, "Month Wise Tyre Trend Report", reportType === 'detail' ? null: true, (reportType === "zone" ? false : true));
                }
            }
        } catch (error) {
            console.error(error);
        } finally {
            setDownloading(false);
        }
    };

    // console.log('detailModalData--',detailModalData);

    console.log('availableCategoryCodes--',availableCategoryCodes);

    const getHeaders = () => {
        switch (searchReportType) {
            case "zone":
                return (
                    <>
                        <TH scope="col">Zone</TH>
                        {data.months?.map((month) => (
                            <TH scope="col">
                                {monthMap[parseInt(month?.split("-")[1])]}{" "}
                                {month?.split("-")[0]}
                            </TH>
                        ))}
                        <TH scope="col">Total</TH>
                    </>
                );
            case "region":
                return (
                    <>
                        <TH scope="col">S.N.</TH>
                        <TH scope="col">Zone</TH>
                        <TH scope="col">Region</TH>
                        {data.months?.map((month) => (
                            <TH scope="col">
                                {monthMap[parseInt(month?.split("-")[1])]}{" "}
                                {month?.split("-")[0]}
                            </TH>
                        ))}
                        <TH scope="col">Total</TH>
                    </>
                );
            case "fleet":
                return (
                    <>
                        <TH scope="col">S.N.</TH>
                        <TH scope="col">Fleet Name</TH>
                        <TH scope="col">Hub Name</TH>
                        <TH scope="col">Supplied Stencil</TH>
                        <TH scope="col">Accepted Tyre</TH>
                        <TH scope="col">Tyre Pending</TH>
                    </>
                );
            case "detail":
                return (
                    <>
                        <TH scope="col">S.N.</TH>
                        <TH scope="col">GRN Date</TH>
                        <TH scope="col">Fleet Name</TH>
                        <TH scope="col">Hub Name</TH>
                        <TH scope="col">Depot Code</TH>
                        <TH scope="col">Region</TH>
                        <TH scope="col">Zone</TH>
                        <TH scope="col">Tyre Size</TH>
                        <TH scope="col">Tyre Brand</TH>
                        <TH scope="col">GRN Number</TH>
                        <TH scope="col">Stencil Number</TH>
                        <TH scope="col">Accepted Date</TH>
                        <TH scope="col">Accepted By</TH>
                        <TH scope="col">Fitment Date</TH>
                        <TH scope="col">In Stock</TH>
                        <TH scope="col">For</TH>
                        <TH scope="col">Vehicle</TH>
                        <TH scope="col">First Enrollment vehicle</TH>
                    </>
                );

            default:
               <>
                    </>
        }
    };
    

    return (
        <>
            <div>
                <div className="w-full px-8 flex justify-center items-center gap-4">
                    <label className="w-full py-3">
                        Select Fleets
                        <ReactSelect
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderColor: "transparent",
                                    minWidth: "100%",
                                    "&:hover": {
                                        borderColor: "rgb(34 197 94)",
                                    },
                                }),
                            }}
                            className="shadow-md rounded-md py-1 mb-2"
                            options={getFleetOptions()}
                            value={
                                selectedFleets &&
                                selectedFleets?.map((fleet) => {
                                    return {
                                        value: fleet,
                                        label: getFleetOptions()?.find((item) => item?.value === fleet)
                                            ?.label,
                                    };
                                })
                            }
                            onChange={(value) => {
                                let allValues = value?.map((item) => item.value);
                                if (allValues?.includes("clear")) {
                                    setSelectedFleets([]);
                                    setSelectedHubs([]);
                                    return;
                                }
                                if (!selectedFleets?.includes("all") && allValues.includes("all")) {
                                    setSelectedFleets(["all"]);
                                    return;
                                }

                                if (selectedFleets.includes("all")) {
                                    value = value.filter(item => item.value !== "all")
                                }

                                let selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                                    value?.map((item) => item.value)?.includes(fleet._id)
                                );

                                let selectedHubsVal = allHubs?.data?.filter((hub) =>
                                    selectedHubs?.map((item) => item)?.includes(hub.hubCode)
                                );

                                setSelectedHubs(
                                    selectedHubsVal
                                        ?.filter((hub) =>
                                            selectedFleetsVal?.find(
                                                (fleet) => fleet.fleetCode === hub.fleetCode
                                            )
                                        )
                                        .map((hub) => hub.hubCode)
                                );

                                setSelectedFleets(value.map((fleet) => fleet.value));
                            }
                            }
                            name="fleets"
                            isMulti={true}
                        />
                    </label>

                    <label className="w-full py-3">
                        Select Hubs
                        <ReactSelect
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderColor: "transparent",
                                    minWidth: "100%",
                                    "&:hover": {
                                        borderColor: "rgb(34 197 94)",
                                    },
                                }),
                            }}
                            className="shadow-md rounded-md py-1 mb-2"
                            options={getHubOptions()}
                            value={
                                selectedHubs &&
                                selectedHubs?.map((hub) => {
                                    return {
                                        value: hub,
                                        label: getHubOptions()?.find((item) => item.value === hub)
                                            ?.label,
                                    };
                                })
                            }
                            onChange={(value) => {
                                const allValues = value?.map((item) => item.value);
                                if (allValues.includes("clear")) {
                                    setSelectedHubs([])
                                    return;
                                }
                                if (!selectedHubs?.includes("all") && allValues.includes("all")) {
                                    let selectedFleetCodes = allFleets?.data?.filter((fleet) =>
                                        selectedFleets?.includes(fleet._id)
                                    )?.map(fleet => fleet.fleetCode);

                                    const selectedHubsData = allHubs?.data?.filter(hub => selectedFleetCodes?.includes(hub.fleetCode))

                                    const mp = fleetMap;
                                    selectedHubsData.map(hub => {
                                        if (selectedFleetCodes?.includes(hub.fleetCode)) {
                                            if (mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
                                            mp[hub.fleetCode] = [...mp[hub.fleetCode], hub.hubCode]
                                        }
                                    })

                                    setFleetMap(mp);
                                    setSelectedHubs(["all"])
                                }
                                else {
                                    value = value.filter(value => value.value !== "all")
                                    let selectedFleetCodes = allFleets?.data?.filter((fleet) =>
                                        selectedFleets?.includes(fleet._id)
                                    )?.map(fleet => fleet.fleetCode);

                                    const selectedHubsData = allHubs?.data?.filter(hub => allValues?.includes(hub._id))

                                    const mp = {};
                                    selectedHubsData.map(hub => {
                                        mp[hub.fleetCode] = [];
                                    })

                                    selectedHubsData.map(hub => {
                                        if (selectedFleetCodes?.includes(hub.fleetCode)) {
                                            if (mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
                                            mp[hub.fleetCode] = [...mp[hub.fleetCode], hub.hubCode]
                                        }
                                    })

                                    setFleetMap(mp);
                                    setSelectedHubs(value.map((hub) => hub.value));
                                }
                            }}
                            name="hubs"
                            isMulti={true}
                        />
                    </label>

                    <label className="w-full py-3">
                        Report Type
                        <Select
                            name="reportType"
                            value={reportType}
                            onChange={(e) => setReportType(e.target.value)}
                        >
                            <option value={""}>Select...</option>
                            <option value={"zone"}> Zone Wise</option>
                            <option value={"region"}>Region Wise</option>
                            <option value={"fleet"}>Fleet Wise</option>
                            <option value={"detail"}>Detail</option>
                        </Select>
                    </label>

                    <label className="w-full py-3">
                         For 
                        <Select
                            name="chalansFor"
                            value={chalansFor}
                            onChange={(e) => setChalansFor(e.target.value)}
                        >
                            
                            <option value={""}> All</option>
                            <option value={"Replacement"}>Replacement</option>
                            <option value={"Fitment"}>Fitment</option>
                            <option value={"Pending"}>Fitment Pending</option>
                            <option value={"GRN Pending"}>GRN Pending</option>
                        </Select>
                    </label>

                    <label className="w-full py-3">
                        Select Category
                        <Select
                            name="tyreCategory"
                            value={tyreCategory}
                            onChange={(e) => setTyreCategory(e.target.value)}
                            disabled={loadingCategories}
                        >
                            {loadingCategories ? (
                                <option value=''>Loading categories...</option>
                            ) : (
                                <>
                                    <option value=''> Select....</option>
                                    {
                                      allCategories?.data
                                        ?.filter(item => {
                                            if (availableCategoryCodes.length === 0 && (!selectedHubs.length || !dateFrom || !dateTo)) {
                                                return true;
                                            }
                                            if (availableCategoryCodes.length > 0) {
                                                const categoryCodes = item.catCodes || [];
                                                return categoryCodes.some(code => availableCategoryCodes.includes(code));
                                            }
                                            return true;
                                        })
                                        ?.map(item => <option key={item._id} value={item.categoryName}> {item.categoryName}</option>)  
                                    }
                                </>
                            )}
                        </Select>
                    </label>


                </div>
                <div className="w-full px-8 flex justify-start items-center gap-4">
                    <label>
                        Start Date{" "}
                        <Input
                            type="date"
                            max={getFormattedDate()}
                            name="dateFrom"
                            value={dateFrom}
                            onChange={handleFromDateChange}
                            onBlur={handleDateBlur}
                        />
                    </label>
                    <label>
                        End Date{" "}
                        <Input
                            type="date"
                            min={dateFrom}
                            max={getOneYearFromDate(dateFrom)}
                            name="dateTo"
                            value={dateTo}
                            onChange={(e) => setDateTo(e.target.value)}
                            onBlur={handleDateBlur}
                        />
                    </label>

                    <Button
                        type="button"
                        className = 'mt-5'
                        disabled={!selectedFleets.length || !reportType?.length || !selectedHubs.length || !dateFrom }
                        bgPrimary
                        onClick={() => { setPage(1); getData(reportType === "detail", 1) }}
                        >
                        Search
                    </Button>
                    {downloading ? 'Downloading...' : selectedFleets.length !== 0 && <BiCloudDownload
                        className="w-10 mt-5 h-10 text-green-500 hover:scale-105 cursor-pointer text-center"
                        onClick={() => {
                            getDownloadData();
                        }}
                    />}
                </div>
            </div>
            {isLoading ? (
                <Spinner />
            ) : (
                <div className="flex flex-col m-2 lg:m-10">
                    <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                            <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                    <table className="min-w-full divide-y divide-gray-200">
                                        <thead className="bg-gray-50">
                                            <tr>
                                                {getHeaders()}
                                            </tr>
                                        </thead>
                                        <tbody className="bg-white divide-y divide-gray-200">
                                {(searchReportType !== "detail" ? data?.data : detailModalData?.data)?.map((item, idx) => (
                                    <ViewList
                                        idx={idx}
                                        data={item}
                                        key={item._id}
                                        months={data?.months || detailModalData?.months}
                                        fleetMap={fleetMap}
                                        fleetId={allFleets?.data?.find(fleet => fleet.fleetCode === item.fleetCode)?._id}
                                        dateFrom={dateFrom}
                                        dateTo={dateTo}
                                        reportType={searchReportType}
                                        searchReportType={searchReportType}
                                        selectedFleets={selectedFleets}
                                        allFleets={allFleets}
                                        allHubs={allHubs}
                                        selectedHubs={selectedHubs} 
                                        getHubOptions = {getHubOptions} 
                                        page={page}
                                        limit={limit}
                                        chalansFor={chalansFor}
                                        tyreCategory={allCategories?.data?.find(item => item.categoryName === tyreCategory)?.catCodes}
                                    />
                                ))}

                                           

                                        </tbody>
                                        <tfoot>
                                        {
                                            searchReportType === "detail" ? <></> : data?.totalRow ? (
                                                    <tr className="text-gray-600 font-semibold bg-green-100">
                                                  
                                                        <TD colSpan={searchReportType === "region" || searchReportType === "fleet"? 3: 1} className="text-center">TOTAL</TD>
                                                        {searchReportType === "fleet" ? (<>
                                                            
                                                            <TD className="text-center" key={`fleet-total`}>
                                                            {data?.totalRow?.total || 0}
                                                        </TD>
                                                        <TD className="text-center" key={`fleet-total`}>
                                                        {(data?.totalRow?.accepted || 0) + data?.totalRow?.acceptedWithChanges || 0}
                                                    </TD>
                                                    <TD className="text-center" key={`fleet-total`}>
                                                    {data?.totalRow?.pending || 0}
                                                </TD>
                                                </>
                                                        ) : (
                                                            <>
                                                                {data.months.map((month) => {
                                                                    // console.log('month--',month,'data--',data.data[0]);
                                                                    
                                                                    return (
                                                                        <TD className="text-center" key={month}>
                                                                            {data.totalRow[month] || 0}
                                                                        </TD>
                                                                    );
                                                                })}
                                                                <TD className="text-center">{data.totalRow?.total ?? 0}</TD>
                                                            </>
                                                        )}
                                                    </tr>
                                            ) : (
                                                <></>
                                            )
                                        }
                                        </tfoot>
                                        

                                    </table>
                            </div>
                        </div>
                    </div>
                    {
                                        searchReportType === "detail" ? (
                                            detailModalData && detailModalData.paginate && detailModalData.paginate.total && (
                                                <div className="container mx-auto flex justify-center items-center gap-2 py-5">
                                                    <Button
                                                        onClick={() => {
                                                            setPage((p) => Math.max(p - 1, 1));
                                                        }}
                                                        disabled={page === 1}
                                                        className="disabled:pointer-events-none disabled:opacity-70 px-0 "
                                                        primary
                                                    >
                                                        <div className="flex gap-1 items-center">
                                                            <IoMdArrowBack />
                                                            Prev Page
                                                        </div>
                                                    </Button>
                                                    <span className="text-gray-600 px-4">{`showing: ${(page - 1) * limit + 1
                                                        } - ${Math.min(detailModalData?.paginate?.total, page * limit)} of ${detailModalData.paginate.total
                                                        }`}</span>

                                                    {detailModalData.paginate.total > page * limit && (
                                                        <Button
                                                            onClick={() => {
                                                                //console.log("setting pages")
                                                                setPage((p) => Math.min(p + 1, detailModalData?.paginate?.total));
                                                            }}
                                                            disabled={page === detailModalData?.paginate?.total}
                                                            className="disabled:pointer-events-none disabled:opacity-70 px-0 "
                                                            primary
                                                        >
                                                            <div className="flex gap-1 items-center">
                                                                Next Page
                                                                <IoMdArrowForward />
                                                            </div>
                                                        </Button>
                                                    )}
                                                </div>
                                            )) : <></>
                                    }
                </div>
            )}
        </>
    )
}

export default MonthWiseTyreTrendReport;

const getZoneName = (code)=>{
    switch(code){
        case "NZ": return "North Zone";
        case "SZ": return "South Zone";
        case "WZ": return "West Zone";
        case "EZ": return "East Zone";
        case 'CZ': return "Central Zone";
        case "TZ": return "South Zone 2";
        case "O": return "Other";
        default: return code;
    }
}
const ViewList = ({ idx, data, months, fleetMap, fleetId, selectedReasons, dateFrom, dateTo, reportType, soldOut, getHubOptions,
    allFleets,allHubs,selectedFleets,selectedHubs, chalansFor, tyreCategory,
    searchReportType, page, limit }) => {
        console.log('chalansFor--',chalansFor);
        
    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState([]);
    const [modalQuery, setModalQuery] = useState(null)
    const [downloadTitle , setDownloadTitle] = useState('Month Wise Report Download')
    const [fleet, setFleet] = useState("");
    const [hub, setHub] = useState("");
    const [isLoading, setIsLoading] = useState(true)

    // console.log('viewData--',data);

    const getModalData = async (modalQueryProp) => {
        if ((dateFrom && !dateTo) || (!dateFrom && dateTo)) {
            toast.error("Both Start Date and End Date must be provided together.");
            return;
          }
        setShowModal(true);
        if (modalQueryProp) {
            setIsLoading(true);

            const fleetsToSend = selectedFleets.includes("all")
                ? allFleets?.data?.map(fleet => fleet._id).join(",")
                : selectedFleets.join(",");

            const hubsToSend = selectedHubs.includes("all")
                ? getHubOptions().map(item => item.value)?.join(",")
                : selectedHubs.join(",");
            
            const payload = {
                // fleets: fleetsToSend,
                from: dateFrom,
                to: dateTo,
                for: chalansFor,
                ...modalQueryProp.hubCode ? { hubCodes: modalQueryProp.hubCode } : { hubCodes: hubsToSend },
                fetchAll: 1,
                status: modalQueryProp.status,
                reportType: modalQueryProp.reportType,
                selectedMonthYear: modalQueryProp.title.split(":")[1]?.trim(),
                zoneName: modalQueryProp?.zoneName,
                regionName: modalQueryProp?.regionName,
                tyreCategory,
            };
    
            try {
                const dt = await createDocument("/report/monthWiseSuppliedTyresTrend/modalInfo", payload);
                console.log('dt--',dt);
                setModalData(dt);
            } catch (error) {
                console.error("Error fetching modal data:", error);
            }
        }
        setIsLoading(false);
    };    

    // console.log('modalData--',modalData);

    const downloadDiv = (data) => {

        // console.log('data--',data);

        return <div class="flex gap-2 items-center justify-center">
            <span
                className="hover:text-green-500 cursor-pointer"
                onClick={async() => {
                    if ((dateFrom && !dateTo) || (!dateFrom && dateTo)) {
                        toast.error("Both Start Date and End Date must be provided together.");
                        return;
                      }
                    setFleet(data?.fleet);
                    setModalQuery(data)
                    await getModalData(data)
                }}
            >
                {data?.count}
            </span>
        </div>
    }

    // const modalHandler = useCallback(
    //     (data) => {
    //         console.log("modal data", data.data)
    //         if (data) {
    //             setModalData(data.data.data);
    //             setShowModal(true);
    //             setDownloadTitle(data?.data?.title)
    //         } else {
    //             setShowModal(false);
    //             setModalData([]);
    //         }
    //     },
    //     [showModal, modalData]
    // );

    const renderRowData = () => {
        console.log("Search report type" , reportType, searchReportType)
        switch (searchReportType) {

            case "zone":
                return (
                    <tr>
                        <TD style={{ fontWeight: 600, opacity: "80%" }}>
                            {data?._id?.Zone}
                        </TD>
    
                        {months.map((month) => {
                            const monthData = data[month]
                            
                            return (
                                <TD key={month}>
                                    {downloadDiv({
                                        count: monthData ? monthData : 0,  
                                        fleet: data?.fleet,
                                        title: "Month Count: " + month,
                                        data: monthData,
                                        reportType:reportType,
                                        zoneName : data?._id?.Zone
                                    })}
                                </TD>
                            );
                        })}
    
                        <TD>
                            {downloadDiv({
                                count: data?.count ?? 0,  
                                title: "Total Count",
                                data: data?.count,
                                reportType:reportType,
                                zoneName : data?._id?.Zone

                            })}
                        </TD>
                    </tr>
                );
    
            case "region":
                return (
                    <tr>
                        <TD>{idx + 1}</TD>
                        <TD style={{ fontWeight: 600, opacity: "80%" }}>
                            {data.Zone == null ? "---" : data.Zone}
                        </TD>
                        <TD>{data._id.Region == null ? "---" : data._id.Region}</TD>
    
                        {months.map((month) => {
                            const monthData = data[month]
                            return (
                                <TD key={month}>
                                    {downloadDiv({
                                        count: monthData ? monthData : 0,  
                                        fleet: data.fleet,
                                        title: "Month Count: " + month,
                                        data: monthData,
                                        reportType:reportType,
                                        regionName : data._id.Region,
                                        zoneName : data.Zone,
                                    })}
                                </TD>
                            );
                        })}
    
                        <TD>
                            {downloadDiv({
                                count: data?.count ?? 0,
                                title: "Total Count",
                                data: data?.count,
                                reportType:reportType,
                                regionName : data._id.Region,
                                zoneName : data.Zone,
                                
                            })}
                        </TD>
                    </tr>
                );

            case "fleet":
                return (
                    <tr className="">
                        <TD>{idx + 1}</TD>
                        <TD>{`${data?.fleet} (${data?.fleetCity ?? "---"})`}</TD>
                        <TD>{data?.hubName}</TD>

                        <TD>
                            {downloadDiv({
                                count: data.sumOfTotaltyres || 0,
                                hubCode: data.hubCode,
                                title: "Supplied Stencils Data",
                                reportType: reportType,
                                status: "",
                            })}
                        </TD>

                        <TD>
                            {downloadDiv({
                                count: (data.sumOfTyreAccepted || 0) + (data.sumOfTyreRejected || 0),
                                hubCode: data.hubCode,
                                title: "Accepted Tyre Data",
                                reportType: reportType,
                                status: "accepted",
                            })}
                        </TD>

                        <TD>
                            {downloadDiv({
                                count: data.sumOfPending || 0,
                                hubCode: data.hubCode,
                                title: "Tyre Pending Data",
                                reportType: reportType,
                                status: "pending"
                            })}
                        </TD>
                    </tr>
                );


            case "detail":
                return (
                    <tr>
                        <TD>{(page-1)*limit + idx + 1}</TD>
                        <TD>{convertSlashToDash(data?.grnDate)}</TD>
                        <TD>{`${data?.fleetName} (${data?.fleetCity ?? "---"})`}</TD>
                        <TD>{data?.hubName}</TD>
                        <TD>{data?.depoCode}</TD>
                        <TD>{data?.region}</TD>
                        <TD>{data?.zone}</TD>
                        <TD>{data?.tyreSize}</TD>
                        <TD>{data?.brand || "---"}</TD>
                        <TD>{data?.Challan_No}</TD>
                        <TD style={{ color: data?.soldOut ? 'red' : 'inherit' }}>{data?.RecvStencil}</TD>
                        <TD>{data?.acceptedAt ? convertToIndianTimezoneAndGetDate(data?.acceptedAt) : convertSlashToDash(data?.grnDate)}</TD>
                        <TD>{data?.acceptedBy}</TD>
                        {/* <TD>{(data?.fitmentDate == null || chalansFor=="Pending" ? "---" : convertSlashToDash(data?.fitmentDate))}</TD> */}
                        <TD style={{ color: !data?.fitmentDate && data?.soldOutDate ? 'red' : 'inherit' }}>
                        {
                            data?.fitmentDate && data?.for !== "Pending"
                            ? convertSlashToDash(data?.fitmentDate)
                            : data?.soldOutDate
                                ? convertSlashToDash(data?.soldOutDate)
                                : "---"
                        }
                        </TD>
                        <TD>{data?.inStock}</TD>
                        <TD>{data?.for === "Pending" ? "Fitment Pending" : titleCase(data?.for)}</TD>
                        <TD>{data?.vehicle}</TD>
                        <TD>{data?.firstEnrollmentVehicle || "---"}</TD>
                    </tr>
                );
    
            default:
                return <></>;
        }
    };

    return (
        <Fragment>
            {showModal && (
                <Modal
                    handleClick={() => setShowModal(false)}
                    title={"Month-wise Tyre Trend Details"}
                    className="max-w-2xl"
                >
                    {
                        isLoading?
                        <div className="mb-6">
                        <Spinner/>
                        </div>:
                    <>

                    <h1 className="w-full flex justify-end text-end px-2 my-1">
                        <Button
                            onClick={() => {
                                exportExcelStyled(
                                    modalData?.data?.map((item) => ({
                                        "GRN Date": item.grnDate,
                                        "FLEET NAME": `${item?.fleetName} (${item?.fleetCity ?? "---"})`,
                                        "HUB NAME": item.hubName,
                                        "DEPOT CODE	": item?.depoCode,
                                        "REGION": item?.region,
                                        "ZONE": item?.zone,
                                        "TYRE SIZE": item.tyreSize,
                                        "Tyre Brand": item?.brand || "---",
                                        "GRN NUMBER	": item.Challan_No,
                                        "Stencil Number": item.RecvStencil,
                                        "Accepted Date": /accept/.test(item.RecvRemark) ?
                                        item.acceptedAt ? convertToIndianTimezoneAndGetDate(item.acceptedAt): item.grnDate
                                        : "---",
                                        "Accepted By": item.acceptedBy,
                                        "Fitment Date": item.fitmentDate == null
                                        ? (item.soldOutDate ? item.soldOutDate : "---")
                                        : item.fitmentDate,

                                        "In Stock" : item.inStock,
                                        "For" : item.for === "Pending" ? "Fitment Pending" : titleCase(item.for),
                                        "Vehicle" : item.vehicle,
                                        "First Enrollment vehicle" : item?.firstEnrollmentVehicle || "---"
                                    })),
                                    downloadTitle?.split(" ").join("_") + "_Data",
                                    {
                                        redColumn: "Stencil Number",
                                        redRows: modalData?.data?.map((item) => !!item?.soldOut) || [],
                                    }
                                );

                            }}
                            className=" text-blue-500 hover:scale-105 cursor-pointer text-right"
                        >
                            Download
                        </Button>
                    </h1>

                    
                    
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <TH scope="col">S.N.</TH>
                                <TH scope="col">GRN Date</TH>
                                <TH scope="col">Fleet Name</TH>
                                <TH scope="col">Hub Name</TH>
                                <TH scope="col">Depot Code</TH>
                                <TH scope="col">Region</TH>
                                <TH scope="col">Zone</TH>
                                <TH scope="col">Tyre Size</TH>
                                <TH scope="col">Tyre Brand</TH>
                                <TH scope="col">GRN Number</TH>
                                <TH scope="col">Stencil Number</TH>
                                <TH scope="col">Accepted Date</TH>
                                <TH scope="col">Accepted By</TH>
                                <TH scope="col">Fitment Date</TH>
                                <TH scope="col">In Stock</TH>
                                <TH scope="col">For</TH>
                                <TH scope="col">Vehicle</TH>
                                <TH scope="col">First Enrollment vehicle</TH>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                        {modalData &&
                                modalData?.data?.length > 0 &&
                                modalData?.data?.map((scrap, index) => {
                                    console.log('scrap--',scrap);
                                   return <tr>
                                        <TD>{index + 1}</TD>
                                        <TD>{convertSlashToDash(scrap?.grnDate)}</TD>
                                        <TD>{`${scrap?.fleetName} (${scrap?.fleetCity ?? "---"})`}</TD>
                                        <TD>{scrap?.hubName}</TD>
                                        <TD>{scrap?.depoCode}</TD>
                                        <TD>{scrap?.region}</TD>
                                        <TD>{scrap?.zone}</TD>
                                        <TD>{scrap?.tyreSize}</TD>
                                        <TD>{scrap?.brand || "---"}</TD>
                                        <TD>{scrap?.Challan_No}</TD>
                                        <TD style={{ color: scrap?.soldOut ? 'red' : 'inherit' }}>{scrap?.RecvStencil}</TD>
                                        <TD>{/accept/.test(scrap.RecvRemark) ?
                                        scrap.acceptedAt ? convertToIndianTimezoneAndGetDate(scrap.acceptedAt): convertSlashToDash(scrap.grnDate)
                                        : "---"}</TD>
                                        <TD>{convertSlashToDash(scrap?.acceptedBy)}</TD>

                                        {/* <TD>
                                        {
                                            scrap?.fitmentDate && scrap?.for !== "Pending"
                                            ? convertSlashToDash(scrap.fitmentDate)
                                            : scrap?.soldOutDate
                                                ? convertSlashToDash(scrap.soldOutDate)
                                                : "---"
                                        }
                                        </TD> */}

                                        <TD style={{ color: !scrap?.fitmentDate && scrap?.soldOutDate ? 'red' : 'inherit' }}>
                                        {
                                            scrap?.fitmentDate && scrap?.for !== "Pending"
                                            ? convertSlashToDash(scrap.fitmentDate)
                                            : scrap?.soldOutDate
                                                ? convertSlashToDash(scrap.soldOutDate)
                                                : "---"
                                        }
                                        </TD>


                                        <TD>{scrap?.inStock}</TD>
                                        <TD>{scrap?.for === "Pending" ? "Fitment Pending" : titleCase(scrap?.for)}</TD>
                                        <TD>{scrap?.vehicle}</TD>
                                        <TD>{scrap?.firstEnrollmentVehicle || "---"}</TD>
                                    </tr>
})}
                    </tbody>
                    </table>


                    </>

}

                </Modal>
            )}

            {renderRowData()}
            
        </Fragment>
    )

}